import type { BrandStore, FlotiqStore } from "@jti/fe-common";
import { BRAND_STORES } from "@jti/fe-common";

export function isBrandStore(store: FlotiqStore) {
  if (store.storetype) {
    return BRAND_STORES.includes(store.storetype as BrandStore);
  }

  return false;
}
